import { roles } from "@constants";

export const isAdmin = (role: string) => !roles.company.includes(role);
